import { StrongText, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { visitHistoryTranslationKeys } from '../../../translations';
import { VisitFormController } from '../../form/visitForm.types';
import { ProceduresFormTab } from '../../form/tabs/procedures/ProceduresFormTab';
import { StyledPrescriptionVisitDataModalField } from '../PrescriptionVisitDataModal.styled';

type ProceduresFieldProps = Pick<VisitFormController, 'register'> & {
   readonly dictionaryValidOn: Date;
};

export const ProceduresField = (props: ProceduresFieldProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitDataModalField>
         <StyledFlex direction={'column'} gap={4}>
            <StrongText testId={'proceduresLabel'}>
               <Translate>{visitHistoryTranslationKeys.interviewTabs.procedures}</Translate>
            </StrongText>
            <ProceduresFormTab register={props.register} dictionaryValidOn={props.dictionaryValidOn} />
         </StyledFlex>
      </StyledPrescriptionVisitDataModalField>
   );
};
